"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BreadcrumbsWithData = void 0;
var _Breadcrumb = require("./Breadcrumb");
var _HomeBreadcrumb = require("./HomeBreadcrumb");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const BreadcrumbsWithData = (param)=>{
    let { siteMapItemCollection } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        isCategoryPage: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_HomeBreadcrumb.HomeBreadcrumb, {}),
            siteMapItemCollection.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_Breadcrumb.Breadcrumb, {
                    ...item
                }, item.path))
        ]
    }, window.location.pathname);
};
exports.BreadcrumbsWithData = BreadcrumbsWithData;
